import { render, staticRenderFns } from "./1-bg.vue?vue&type=template&id=5c945ca8&"
import script from "./1-bg.vue?vue&type=script&lang=js&"
export * from "./1-bg.vue?vue&type=script&lang=js&"
import style0 from "./1-bg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports